<div class="table-responsive">
    <table>
        <thead>
            <tr>
                <!-- Periods -->
                <th>{{ 'translate_periods' | translate }}</th>

                <!-- Target -->
                @if (!kpiResult.kpi.isTrend) {
                    <th>
                        <p>{{ 'translate_target' | translate }}</p>
                        <p class="mx-auto max-w-xs text-xs text-slate-400">
                            @switch (kpiResult.kpi.direction) {
                                @case ('decrease') {
                                    <span>
                                        {{
                                            'translate_decrease_is_best'
                                                | translate
                                        }}
                                    </span>
                                }
                                @case ('increase') {
                                    <span>
                                        {{
                                            'translate_increase_is_best'
                                                | translate
                                        }}
                                    </span>
                                }
                            }
                        </p>
                    </th>
                }

                <!-- A -->
                <th>
                    <p>{{ 'translate_a_value' | translate }}</p>
                    <p
                        class="mx-auto max-w-xs whitespace-normal text-xs text-slate-400"
                    >
                        {{ kpiResult.formulaDescriptionA }}
                    </p>
                    @if (kpiResult.kpi.dataEntryMethod === 'dynamic') {
                        <small class="text-xs text-slate-400">
                            {{
                                'translate_data_entry_disabled_dynamic_data_entry_only'
                                    | translate
                            }}
                        </small>
                    }
                </th>

                <!-- B -->
                @if (formula?.includes('B')) {
                    <th>
                        <p>{{ 'translate_b_value' | translate }}</p>
                        <p
                            class="mx-auto max-w-xs whitespace-normal text-xs text-slate-400"
                        >
                            {{ kpiResult.formulaDescriptionB }}
                        </p>
                        @if (kpiResult.kpi.dataEntryMethod === 'dynamic') {
                            <small class="text-xs text-slate-400">
                                {{
                                    'translate_data_entry_disabled_dynamic_data_entry_only'
                                        | translate
                                }}
                            </small>
                        }
                    </th>
                }
                @if (mode === 'edit' && periods[0]?.id) {
                    <!-- Result -->
                    <th>
                        {{ 'translate_result' | translate }}
                    </th>
                    <!-- Achieved -->
                    @if (!kpiResult.kpi.isTrend) {
                        <th>
                            {{ 'translate_achieved' | translate }}
                        </th>
                    }
                    <!-- Actions -->
                    <th></th>
                }
            </tr>
        </thead>
        <tbody>
            @for (period of periods; track $index) {
                <tr
                    class="full-table-row"
                    [class.bg-secondary-100]="
                        kpiResult.currentPeriod > period.period
                    "
                >
                    <!-- Periods -->
                    <td class="text-center font-bold">
                        @switch (measurementCycle) {
                            @case ('semi_annual') {
                                {{ 'translate_year_half' | translate }}
                            }
                            @case ('quarter') {
                                {{ 'translate_quarter' | translate }}
                            }
                            @case ('month') {
                                {{ 'translate_month' | translate }}
                            }
                        }
                        {{ period.period + 1 }}
                    </td>
                    <!-- Target -->
                    @if (!kpiResult.kpi.isTrend) {
                        <td>
                            <app-kpi-period-value-input
                                [units]="units"
                                [decimalPlaces]="kpiResult.decimalPlaces"
                                [disabled]="
                                    type === 'data-entry-response' ||
                                    period.isApproved ||
                                    (permissionList.kpiResultEntry
                                        | hasPermissionId
                                        | async) !== true
                                "
                                [(ngModel)]="period.target"
                                [ngModelOptions]="{ standalone: true }"
                            ></app-kpi-period-value-input>
                        </td>
                    }
                    <!-- A -->
                    <td>
                        <app-kpi-period-value-input
                            [units]="units"
                            [decimalPlaces]="kpiResult.decimalPlaces"
                            [disabled]="
                                type === 'data-entry-response'
                                    ? (currentTransferAssignee !==
                                          'data_entry' &&
                                          currentTransferAssignee !==
                                              'create_request') ||
                                      readOnly
                                    : period.isApproved ||
                                      inputModeA === 'auto' ||
                                      (permissionList.kpiResultEntry
                                          | hasPermissionId
                                          | async) !== true ||
                                      kpiResult.kpi.dataEntryMethod ===
                                          'dynamic'
                            "
                            [(ngModel)]="period.a"
                            [ngModelOptions]="{ standalone: true }"
                        ></app-kpi-period-value-input>
                    </td>
                    <!-- B -->
                    @if (formula.includes('B')) {
                        <td>
                            <app-kpi-period-value-input
                                [units]="units"
                                [decimalPlaces]="kpiResult.decimalPlaces"
                                [disabled]="
                                    type === 'data-entry-response'
                                        ? (currentTransferAssignee !==
                                              'data_entry' &&
                                              currentTransferAssignee !==
                                                  'create_request') ||
                                          readOnly
                                        : period.isApproved ||
                                          inputModeB === 'auto' ||
                                          (permissionList.kpiResultEntry
                                              | hasPermissionId
                                              | async) !== true ||
                                          kpiResult.kpi.dataEntryMethod ===
                                              'dynamic'
                                "
                                [(ngModel)]="period.b"
                                [ngModelOptions]="{ standalone: true }"
                            ></app-kpi-period-value-input>
                        </td>
                    }
                    @if (mode === 'edit' && periods[0]?.id) {
                        <!-- Result -->
                        <td class="text-center">
                            {{
                                period.result
                                    | formatKpiResult
                                        : units
                                        : unitsDescription
                                        : true
                                        : kpiResult.decimalPlaces
                            }}
                        </td>
                        <!-- Achieved -->
                        @if (!kpiResult.kpi.isTrend) {
                            <td class="full-table-cell">
                                <app-achieved-container
                                    [achieved]="period.achieved"
                                    [decimalPlaces]="kpiResult.decimalPlaces"
                                ></app-achieved-container>
                            </td>
                        }
                        <!-- Actions -->
                        <td>
                            <div class="flex items-center justify-center gap-2">
                                <!-- Result Analysis -->
                                <app-period-button
                                    title="translate_result_analysis"
                                    icon="fa-magnifying-glass-chart"
                                    [isDone]="
                                        !!period.resultAnalysisAr ||
                                        !!period.resultAnalysisEn
                                    "
                                    [isDisabled]="isSubmitting"
                                    [callbackFunction]="
                                        showResultAnalysisDialog.bind(
                                            this,
                                            period
                                        )
                                    "
                                ></app-period-button>
                                <!-- Improvement Procedures -->
                                <app-period-button
                                    title="translate_improvement_procedures"
                                    icon="fa-arrow-up-right-dots"
                                    [isDone]="
                                        !!period.improvementProcedureAr ||
                                        !!period.improvementProcedureEn
                                    "
                                    [isDisabled]="isSubmitting"
                                    [callbackFunction]="
                                        showImprovementProceduresDialog.bind(
                                            this,
                                            period
                                        )
                                    "
                                    [progress]="
                                        period.improvementProcedureCompletionPercentage
                                    "
                                ></app-period-button>
                                <!-- Attachments -->
                                <app-period-button
                                    title="translate_attachments"
                                    icon="fa-paperclip"
                                    [isDone]="period.attachmentCount > 0"
                                    [isDisabled]="isSubmitting"
                                    [callbackFunction]="
                                        showAttachmentListDialog.bind(
                                            this,
                                            period
                                        )
                                    "
                                    [count]="period.attachmentCount"
                                ></app-period-button>
                                <!-- Capabilities -->
                                <app-period-button
                                    title="translate_capabilities"
                                    icon="fa-screwdriver-wrench"
                                    [isDone]="period.capabilityCount > 0"
                                    [isDisabled]="isSubmitting"
                                    [callbackFunction]="
                                        showCapabilityListDialog.bind(
                                            this,
                                            period
                                        )
                                    "
                                    [count]="period.capabilityCount"
                                ></app-period-button>
                                <!-- Field History -->
                                @if (period.id && isFieldHistoryEnabled) {
                                    <app-period-button
                                        title="translate_history"
                                        icon="fa-clock-rotate-left"
                                        [isDisabled]="isSubmitting"
                                        [callbackFunction]="
                                            showFieldHistoryDialog.bind(
                                                this,
                                                period
                                            )
                                        "
                                    ></app-period-button>
                                }
                                @if (type === 'kpi-result') {
                                    <!-- Period Breakdown -->
                                    @if (isBreakdownEnabled) {
                                        <app-period-button
                                            title="translate_period_breakdown"
                                            icon="fa-list-ul"
                                            [isDisabled]="isSubmitting"
                                            [callbackFunction]="
                                                showBreakdownDialog.bind(
                                                    this,
                                                    period
                                                )
                                            "
                                        ></app-period-button>
                                    }
                                    <!-- Approval and Suggestions -->
                                    <app-period-button
                                        *appHasPermissionId="
                                            permissionList.kpiResultApprove
                                        "
                                        title="translate_approval_and_suggestions"
                                        [icon]="
                                            period.isApproved
                                                ? 'fa-lock'
                                                : 'fa-unlock'
                                        "
                                        [isDone]="period.isApproved"
                                        [isDisabled]="isSubmitting"
                                        [callbackFunction]="
                                            showApprovalDialog.bind(
                                                this,
                                                period
                                            )
                                        "
                                    ></app-period-button>
                                }
                            </div>
                        </td>
                    }
                </tr>
            }
            @if (type === 'kpi-result') {
                <tr class="full-table-row font-bold">
                    <!-- Result Header -->
                    <th class="text-center">
                        {{ 'translate_total' | translate }}
                    </th>
                    <!-- Target -->
                    @if (!kpiResult.kpi.isTrend) {
                        <td class="text-center">
                            {{
                                target
                                    | formatKpiResult
                                        : units
                                        : unitsDescription
                                        : true
                                        : kpiResult.decimalPlaces
                            }}
                        </td>
                    }
                    <!-- Aggregate A -->
                    <td class="text-center">
                        {{
                            kpiResult.aggregateA
                                | formatKpiResult
                                    : 'number'
                                    : ''
                                    : true
                                    : kpiResult.decimalPlaces
                        }}
                    </td>
                    <!-- Aggregate B -->
                    @if (formula.includes('B')) {
                        <td class="text-center">
                            {{
                                kpiResult.aggregateB
                                    | formatKpiResult
                                        : 'number'
                                        : ''
                                        : true
                                        : kpiResult.decimalPlaces
                            }}
                        </td>
                    }
                    @if (mode === 'edit' && periods[0]?.id) {
                        <!-- Result -->
                        <td class="text-center">
                            {{
                                kpiResult.result
                                    | formatKpiResult
                                        : units
                                        : unitsDescription
                                        : true
                                        : kpiResult.decimalPlaces
                            }}
                        </td>
                        <!-- Achieved -->
                        @if (!kpiResult.kpi.isTrend) {
                            <td class="full-table-cell">
                                <app-achieved-container
                                    [achieved]="kpiResult.achieved"
                                    [decimalPlaces]="kpiResult.decimalPlaces"
                                ></app-achieved-container>
                            </td>
                        }
                        <!-- Actions -->
                        <td></td>
                    }
                </tr>
            }
        </tbody>
    </table>
</div>
